import React from 'react'
import { Link } from 'react-router-dom'

export default function Nav({back, forward}) {
  return (
    <ul className='bottom-nav'>
      {back
        ? <li><Link to={back}>{'< Return'}</Link></li>
        : null
      }
      {forward
        ? <li><Link to={forward}>{'Next >'}</Link></li>
        : null
      }
    </ul>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/Nav.js